// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-4f594ae8] .el-dialog__body{\n padding: 10px 20px !important;\n}\n[data-v-4f594ae8] .el-tag:first-child{\n  margin-left: 5px;\n}\n.rawStyle[data-v-4f594ae8]{\n  border-radius: 2px;\n  padding: 5px;\n  border: 1px solid #dcdfe6;\n  margin-bottom: 10px;\n}\n", ""]);
// Exports
module.exports = exports;
